import React from 'react';
import {Box, Typography, Link} from '@mui/material';
import {size} from "@/lib";
import {LinkType, VideoType, ContentBlock} from "@/types";
import LiteYouTube from "@/ui/lite-youtube/lite-youtube";
import ImagesRenderer from "@/ui/images-renderer/images-renderer";

type ServiceContentRendererProps = {
    contentBlocks: ContentBlock[];
};

const ContentArticleReader: React.FC<ServiceContentRendererProps> = ({contentBlocks}) => {


    return (
        <>
            {contentBlocks?.map(({
                                     title,
                                     subTitle,
                                     content,
                                     images: subImages,
                                     heroImage: subHeroImage,
                                     points,
                                     showGallery,
                                     showSlider,
                                     links,
                                     videos,
                                     id
                                 }: ContentBlock) =>
                <Box
                    key={id}
                    sx={(theme) => ({
                        py: 2,
                        pb: 1,
                        [theme.breakpoints.down('md')]: {
                            py: 1,
                            pb: 0,
                        }
                    })}
                >

                    {!!title?.length && (
                        <div className='slide-up'>
                            <Box sx={{py: 2, px: 1}}>
                                <Typography variant='h3' component='h3'>
                                    {title}
                                </Typography>
                            </Box>
                        </div>
                    )}
                    {!!subTitle?.length && (
                        <Box pb={2}>
                            <div className='slide-up'>
                                <Typography variant='h4' component='h2'>
                                    {subTitle}
                                </Typography>
                            </div>
                        </Box>
                    )}
                    {/*hero before content*/}
                    {!!subHeroImage?.url?.length && (
                        <div>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    mt: 1,
                                    mb: 4,
                                    mx: 'auto',
                                    minHeight: '350px',
                                    maxWidth: size.tablet
                                }}
                                className='fade-in'
                            >
                                <img
                                    src={subHeroImage.url}
                                    title={subHeroImage.title}
                                    alt={subHeroImage.title}
                                    // caption={subHeroImage.caption}
                                    // captionPosition={subHeroImage.captionPosition}
                                    // height='auto'
                                    // width='100%'
                                    // displayCaption
                                />
                                {
                                    subHeroImage?.caption && (
                                        <p className="text-left text-sm text-gray-500 mt-2 italic">
                                            {subHeroImage.caption}
                                        </p>
                                    )
                                }
                            </Box>
                        </div>
                    )}

                    {!!content?.length && (
                        <div>
                            <Typography variant='body1' component='p'
                                        sx={(theme) => ({
                                            py: 2,
                                            pb: 1,
                                            [theme.breakpoints.down('md')]: {
                                                py: 0,
                                                pb: 3,
                                                mx: 1,
                                            }
                                        })}>
                                {content}
                            </Typography>
                        </div>
                    )}

                    {/*assets after content*/}
                    {!!subImages?.[0]?.url &&
                        <Box pt={3}><ImagesRenderer images={subImages} showGallery={showGallery}
                                                    showSlider={showSlider}/></Box>}

                    {!!links?.length &&
                        links.map(({linkRef, linkTitle, linkFollow}: LinkType) => <Box
                            key={linkTitle}
                        ><Link
                            href={linkRef}
                            target="_blank"
                            title={linkTitle}
                            underline="always"
                            rel={linkFollow ? 'follow' : 'nofollow'}
                        >{linkTitle}</Link>
                        </Box>)}

                    {!!videos?.length &&
                        videos.map((video: VideoType) => (
                            <Box key={video.videoId} py={2}>
                                <LiteYouTube {...video} />
                            </Box>
                        ))}


                    {!!points?.length && (<ul>
                        {points?.map((point: string, i: number) => (<li key={i}>{point} </li>))}
                    </ul>)}
                </Box>
            )}
        </>
    );
};

export default ContentArticleReader;
